import AutoComplete from ".";
import { CarService } from "../../service/car-service";

const MIN_LENGTH_REQUIRED = 3;

export const googlePlacesOptions = async (input, type, extraParams) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (input.length < MIN_LENGTH_REQUIRED) reject([]);
            const response = await AutoComplete.getInstance(type).getPlaces({ search: input, ...(extraParams || {}) });
            const result = response.map((item) =>
                ({ label: item.description, value: item.place_id, formattedAddress: item.structured_formatting, description: item.description, geometry: item.geometry }));
            resolve(result);
        } catch (err) {
            reject([]);
        }
    });
};

export const pincodeOptions = async (input) => {
    return new Promise(async (resolve, reject) => {
        try {
            let result = [];
            if (input.length < MIN_LENGTH_REQUIRED) {
                reject([]);
            } else {
                const response = await CarService.fetchPincodes({ term: input });
                if (response.data) {
                    result = response.data.map((item) => ({
                        label: item.value,
                        value: item.id
                    }));
                }
            }
            resolve(result);
        } catch (err) {
            reject([]);
        }
    });
};
